import React from 'react';
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryContainer,
  VictoryLabel,
} from 'victory';

export function OpioidChart({ altText, yLimits, data }) {
  return (
    <div>
      {data.length > 1 && (
        <VictoryChart
          height={200}
          minDomain={{ y: 0 }}
          maxDomain={{ y: 100 }}
          domainPadding={{ x: 100 }}
          containerComponent={<VictoryContainer desc={altText} />}
        >
          <VictoryBar
            data={data}
            x="group"
            y="answer"
            alignment="middle"
            labels={({ datum }) => `${datum.answer}%`}
            labelComponent={<VictoryLabel verticalAnchor="end" />}
            style={{
              data: { fill: ({ datum }) => datum.fill },
              labels: { fill: '#000', fontSize: 10 },
            }}
          />

          <VictoryAxis
            crossAxis
            style={{
              axis: { stroke: 'black' },
              tickLabels: { fontSize: 10 },
            }}
          />

          <VictoryAxis
            dependentAxis
            tickValues={yLimits}
            tickFormat={['0%', '100%']}
            style={{
              axis: { stroke: '#fff' },
              axisLabel: { fontSize: 10, padding: 30 },
              grid: { stroke: '#000' },
              tickLabels: { fontSize: 10 },
            }}
          />
        </VictoryChart>
      )}
    </div>
  );
}
